import { useEffect, useState } from "react";
import { FolderOpen, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { getModelsDir } from "@/lib/agent";
import { FolderPickerButton } from "@/components/FolderPickerButton";

export function InstallDialog({ row, onCancel, onConfirm }) {
  const [dir, setDir] = useState("");
  const [loading, setLoading] = useState(false);
  const [hint, setHint] = useState(null);

  useEffect(() => {
    if (!row) return;
    setLoading(true);
    setHint(null);
    getModelsDir()
      .then((d) => {
        setDir(d?.path || d?.default_path || "");
        if (d?.free_gb != null) setHint(`Espacio libre: ${d.free_gb} GB`);
      })
      .catch(() => setHint("El Agent no informó de la carpeta actual; si la dejas vacía usará su carpeta por defecto."))
      .finally(() => setLoading(false));
  }, [row]);

  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="border-[#262626] bg-[#121212]" data-testid="install-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-white">¿Dónde instalar el modelo?</DialogTitle>
          <DialogDescription className="font-mono text-xs text-[#a3a3a3]">
            {row?.repo_id} · pulsa «Elegir carpeta…» y selecciónala en tu Mac (disco interno o externo)
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <div className="relative flex-1">
            <FolderOpen className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#737373]" />
            <Input
              data-testid="install-dir-input"
              value={dir}
              readOnly
              placeholder={loading ? "Consultando al Agent…" : "Carpeta por defecto del Agent"}
              className="border-[#262626] bg-[#0a0a0a] pl-9 font-mono text-xs"
            />
          </div>
          <FolderPickerButton onPicked={setDir} testid="install-dir-pick" />
        </div>
        {hint && <p className="font-mono text-[11px] text-[#737373]" data-testid="install-dir-hint">{hint}</p>}
        <p className="font-mono text-[11px] text-amber-400">
          Requiere el Agent actualizado (krai_agent_plus.py). Reinícialo tras actualizar los archivos.
        </p>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} data-testid="install-dir-cancel">Cancelar</Button>
          <Button
            data-testid="install-dir-confirm"
            disabled={loading || (dir && !dir.trim().startsWith("/"))}
            onClick={() => onConfirm(dir.trim())}
            className="rounded-sm bg-white text-black hover:bg-neutral-200"
          >
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Instalar aquí
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
